// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__123qG","header":"ReportDetails_header__1C0VJ","title":"ReportDetails_title__3GzLV","left":"ReportDetails_left__1gu3P"};